import useEncryption from "./useEncryption";

function useAuthFetch() {

    const { encrypt, decrypt } = useEncryption()

    const customFetch = async (url, method, headers, bodyContent) => {
        try {
            const encryptedRequest = await encrypt(bodyContent)
            const options = {
                method,
                headers,
                body: JSON.stringify({
                    encryptedRequest
                })
            }
            const fetchResponse = await fetch(url, options);
            const responseJSON = await fetchResponse.json()
            const response = await decrypt(responseJSON?.encryptedResponse)

            return { response, status: fetchResponse.status, message: responseJSON?.message };
        } catch (error) {
            console.error("Error in fetch request:", error);
        }
    };

    return customFetch;
}

export default useAuthFetch;
